import React, { useEffect, useState } from "react";
import "./upcoming.css";
import Popupboxx from "../Popupbox/Popupbox";

function Upcoming() {
    // ✅ State to store batch data dynamically
    const [batches, setBatches] = useState([]);
  

    useEffect(() => {
        // ✅ Function to generate upcoming batches for the current month
        const generateMonthlyBatches = () => {
            const today = new Date(); // Current date
            const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // 1st day of the month
            const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1); // 1st day of next month

            const newBatches = []; // Array to hold all generated batches
            const gapDays = 3; // Each batch will be every 3 days apart
            let id = 1; // Serial number for the batch list


            const onlyDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

            // ✅ Loop through the entire month, increasing date by 3 days
            for (
                let d = new Date(startOfMonth);
                d < nextMonth;
                d.setDate(d.getDate() + gapDays)
            ) {
                // Only include future batches (skip past dates)
                if (d >= onlyDate) {
                    newBatches.push({
                        id: id++,
                        date: d.toLocaleDateString("en-GB"), // Format DD/MM/YYYY
                        day: d.toLocaleDateString("en-US", { weekday: "long" }), // Convert date to weekday name (e.g., Monday)
                        mode: "Offline/Online",
                        link: "#", // Replace this with actual batch registration link
                    });
                }
            }

            // ✅ Update state to trigger UI re-render
            setBatches(newBatches);
        };

        // ✅ Run function once when the component loads
        generateMonthlyBatches();

        // ✅ Auto-refresh logic: checks daily if a new month has started
        // If yes → regenerates new batch list for that month
        const monthChecker = setInterval(() => {
            const now = new Date();
            if (now.getDate() === 1) {
                generateMonthlyBatches();
            }
        }, 86400000); // 86,400,000ms = 24 hours

        // ✅ Cleanup function to stop the timer when component unmounts
        return () => clearInterval(monthChecker);
    }, []);
      const [ isPopupOpen, setIsPopupOpen] = useState(false);

    return (
        <>
        <section className="upcoming-section">
            <div className="container">
                {/* ======= Section Title ======= */}
                 <section className="section-margin">
          <div className="headlines-for-all">
            <h4>
              <span>Upcoming </span> Batches
            </h4>
           
          </div>
        </section>

                {/* ======= Batch Table ======= */}
                <div className="table-container">
                    <table className="batch-table">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Date</th>
                                <th>Day</th>
                                <th>Mode</th>
                                <th>Link</th>
                            </tr>
                        </thead>

                        <tbody>
                            {/* ✅ If batches exist, display them in table rows */}
                            {batches.length > 0 ? (
                                batches.map((batch) => (
                                    <tr key={batch.id}>
                                        <td>{batch.id}</td>
                                        <td>{batch.date}</td>
                                        <td>{batch.day}</td>
                                        <td>{batch.mode}</td>
                                        <td>
                                            <a href={batch.link} className="click-link"
                                            onClick={(e) => {
                                                e.preventDefault(); 
                                             setIsPopupOpen(true)}
                                            }>
                                                Click Here
                                            </a>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                // ✅ If no batches available, show fallback message
                                <tr>
                                    <td colSpan="5">No Upcoming Batches</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>

          <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
    );
}

export default Upcoming;
